function RemoveCartItemIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={74}
            height={72}
            viewBox="0 0 74 72"
            {...props}
        >
            <g fill="none" fillRule="evenodd">
                <circle cx={36} cy={36} r={35.5} stroke="#000" />
                <path
                    fill="#000"
                    d="M47.733 47.899c-.755.726-1.782 1.126-2.894 1.126H27.161c-1.112 0-2.14-.4-2.894-1.126-.755-.726-1.124-1.67-1.04-2.655l1.69-15.263c.018-.2.207-.356.432-.356h3.337v2.432c0 .545.496.987 1.108.987.612 0 1.109-.442 1.109-.987v-2.432h10.194v2.432c0 .545.497.987 1.109.987s1.108-.442 1.108-.987v-2.432h3.337c.225 0 .414.156.432.359l1.69 15.258c.084.987-.285 1.93-1.04 2.657zm-16.83-20.382c0-2.505 2.286-4.542 5.097-4.542 2.81 0 5.097 2.037 5.097 4.542v.133H30.903v-.133zm18.39 2.313c-.106-1.222-1.266-2.18-2.642-2.18h-3.337v-.133C43.314 23.923 40.033 21 36 21c-4.033 0-7.314 2.923-7.314 6.517v.133H25.35c-1.376 0-2.536.958-2.641 2.177l-1.69 15.264c-.13 1.52.46 3.032 1.623 4.15C23.803 50.359 25.45 51 27.16 51h17.678c1.71 0 3.358-.641 4.52-1.76 1.163-1.117 1.754-2.63 1.623-4.152l-1.69-15.258z"
                />
                <circle
                    cx={10}
                    cy={10}
                    r={11}
                    fill="#FF4747"
                    stroke="#FFF"
                    strokeWidth={2}
                    transform="translate(52 3)"
                />
                <path d="M56.545 7.545h10.909v10.909H56.545z" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M62 17.545a.67.67 0 01-.422-.148c-.44-.361-.866-.7-1.24-1l-.003-.001c-1.099-.878-2.048-1.635-2.708-2.382-.738-.834-1.082-1.625-1.082-2.489 0-.84.307-1.614.865-2.181.565-.574 1.34-.89 2.183-.89.63 0 1.206.187 1.714.554.256.186.488.413.693.678.204-.265.436-.492.693-.678a2.866 2.866 0 011.714-.553c.842 0 1.617.316 2.182.89.558.567.865 1.341.865 2.181 0 .864-.344 1.655-1.082 2.49-.66.746-1.61 1.503-2.708 2.38-.376.3-.801.64-1.243 1.002a.666.666 0 01-.421.148z"
                />
            </g>
        </svg>
    );
}

export default RemoveCartItemIcon;
